import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import logo from '../assets/LogoW.webp';

export default function AdminLoginPage() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ email: '', password: '' });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const user = await login(form.email, form.password);
      if (user.role !== 'admin') {
        setError('You do not have admin access.');
        return;
      }
      navigate('/admin', { replace: true });
    } catch (err) {
      setError(err.response?.data?.error || 'Login failed.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ minHeight: '100vh', background: '#0B0F1F', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '24px 16px', fontFamily: 'Arial, Helvetica, sans-serif' }}>
      <div style={{ width: '100%', maxWidth: 440 }}>
        <div style={{ textAlign: 'center', marginBottom: 32 }}>
          <Link to="/"><img src={logo} alt="PixlyBooth" style={{ maxWidth: 160 }} /></Link>
        </div>

        <div style={{ background: 'linear-gradient(135deg, #101428 0%, #0D0F20 100%)', borderRadius: 18, padding: 32, border: '1px solid rgba(159,92,255,0.3)', boxShadow: '0 20px 60px rgba(0,0,0,0.5)' }}>
          {/* Admin badge */}
          <div style={{ display: 'inline-block', background: 'rgba(159,92,255,0.12)', color: '#9F5CFF', fontSize: 11, fontWeight: 700, padding: '4px 12px', borderRadius: 50, border: '1px solid rgba(159,92,255,0.3)', marginBottom: 16, textTransform: 'uppercase', letterSpacing: '0.08em' }}>
            Admin Access
          </div>
          <h1 style={{ margin: '0 0 4px', fontSize: 22, color: '#9F5CFF', fontWeight: 700 }}>Admin Portal</h1>
          <p style={{ margin: '0 0 28px', fontSize: 13, color: '#a0a0b8' }}>Sign in to the Pixly Booth admin panel</p>

          {error && (
            <div style={{ background: 'rgba(227,67,100,0.1)', border: '1px solid rgba(227,67,100,0.3)', borderRadius: 10, padding: '12px 16px', marginBottom: 20, color: '#E34364', fontSize: 13 }}>
              {error}
            </div>
          )}

          <form onSubmit={handleSubmit}>
            <div style={{ marginBottom: 16 }}>
              <label style={{ display: 'block', fontSize: 12, color: '#a0a0b8', marginBottom: 6, textTransform: 'uppercase', letterSpacing: '0.05em' }}>Admin Email</label>
              <input
                type="email" required
                value={form.email} onChange={e => setForm({ ...form, email: e.target.value })}
                style={{ width: '100%', background: 'rgba(255,255,255,0.05)', border: '1px solid rgba(255,255,255,0.1)', borderRadius: 10, padding: '12px 14px', color: '#fff', fontSize: 14, outline: 'none', boxSizing: 'border-box' }}
                placeholder="admin@pixlybooth.com"
              />
            </div>
            <div style={{ marginBottom: 28 }}>
              <label style={{ display: 'block', fontSize: 12, color: '#a0a0b8', marginBottom: 6, textTransform: 'uppercase', letterSpacing: '0.05em' }}>Password</label>
              <input
                type="password" required
                value={form.password} onChange={e => setForm({ ...form, password: e.target.value })}
                style={{ width: '100%', background: 'rgba(255,255,255,0.05)', border: '1px solid rgba(255,255,255,0.1)', borderRadius: 10, padding: '12px 14px', color: '#fff', fontSize: 14, outline: 'none', boxSizing: 'border-box' }}
                placeholder="••••••••"
              />
            </div>

            <button
              type="submit" disabled={loading}
              style={{ width: '100%', background: loading ? '#555' : '#9F5CFF', color: '#fff', border: 'none', borderRadius: 50, padding: '14px 0', fontSize: 14, fontWeight: 700, cursor: loading ? 'not-allowed' : 'pointer' }}
            >
              {loading ? 'Signing in…' : 'Enter Admin Panel →'}
            </button>
          </form>
        </div>

        <p style={{ textAlign: 'center', marginTop: 20, fontSize: 12, color: '#555' }}>
          <Link to="/" style={{ color: '#555', textDecoration: 'none' }}>← Back to homepage</Link>
        </p>
      </div>
    </div>
  );
}
